<template>
  <div>
    <div class="page-head">
      <div>
        <h2>地图点位</h2>
        <p>维护景点地图上的点位名称、区域和坐标。</p>
      </div>
      <el-button type="primary" @click="openCreate">新增点位</el-button>
    </div>

    <el-card shadow="never">
      <el-form :inline="true" :model="filters" size="small">
        <el-form-item label="关键词"><el-input v-model="filters.keyword" placeholder="点位名称/区域/说明" clearable /></el-form-item>
        <el-form-item label="显示状态">
          <el-select v-model="filters.status" placeholder="全部" clearable>
            <el-option label="显示" value="active" />
            <el-option label="隐藏" value="inactive" />
          </el-select>
        </el-form-item>
        <el-form-item><el-button type="primary" @click="fetchList">查询</el-button><el-button @click="reset">重置</el-button></el-form-item>
      </el-form>

      <paged-table :rows="rows" :loading="loading" :page="page" :page-size="pageSize" :total="total" @page-change="page = $event; fetchList()" @size-change="pageSize = $event; page = 1; fetchList()">
        <el-table-column prop="id" label="ID" width="80" />
        <el-table-column prop="name" label="点位名称" min-width="180" />
        <el-table-column prop="scenic_name" label="关联景点" min-width="160" />
        <el-table-column prop="area_label" label="区域" width="130" />
        <el-table-column prop="point_x" label="X 坐标" width="100" />
        <el-table-column prop="point_y" label="Y 坐标" width="100" />
        <el-table-column prop="status" label="显示状态" width="150">
          <template slot-scope="{ row }">
            <el-switch :value="row.status === 'active'" active-text="显示" inactive-text="隐藏" @change="changeStatus(row, $event ? 'active' : 'inactive')" />
          </template>
        </el-table-column>
        <el-table-column prop="sort_order" label="排序" width="130">
          <template slot-scope="{ row }"><sort-input :value="Number(row.sort_order || 0)" @change="changeSort(row, $event)" /></template>
        </el-table-column>
        <el-table-column label="操作" width="150" fixed="right">
          <template slot-scope="{ row }">
            <el-button type="text" @click="openEdit(row)">编辑</el-button>
            <el-button type="text" class="danger-text" @click="remove(row)">删除</el-button>
          </template>
        </el-table-column>
      </paged-table>
    </el-card>

    <el-dialog :title="drawerMode === 'create' ? '新增地图点位' : '编辑地图点位'" :visible.sync="drawerVisible" width="540px" destroy-on-close>
      <el-form ref="form" class="drawer-form" :model="form" :rules="rules" label-width="120px">
        <el-form-item label="关联景点" prop="scenic_id"><el-select v-model="form.scenic_id" filterable placeholder="请选择已上架景点"><el-option v-for="item in scenicOptions" :key="item.id" :label="`${item.name}${item.area ? `（${item.area}）` : ''}`" :value="item.id" /></el-select></el-form-item>
        <el-form-item label="点位名称" prop="name"><el-input v-model="form.name" /></el-form-item>
        <el-form-item label="区域标签"><el-input v-model="form.area_label" /></el-form-item>
        <el-form-item label="X 坐标"><el-input-number v-model="form.point_x" :min="0" :max="100" :precision="2" /></el-form-item>
        <el-form-item label="Y 坐标"><el-input-number v-model="form.point_y" :min="0" :max="100" :precision="2" /></el-form-item>
        <el-form-item label="说明"><el-input v-model="form.description" type="textarea" :rows="4" /></el-form-item>
      </el-form>
      <div class="drawer-footer">
        <el-button @click="drawerVisible = false">取消</el-button>
        <el-button type="primary" :loading="saving" @click="save">保存</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import PagedTable from "../components/PagedTable.vue";
import SortInput from "../components/SortInput.vue";
import { changeResourceStatus, createResource, deleteResource, listResource, updateResource } from "../api/resources";

export default {
  name: "ScenicMapPointsManage",
  components: { PagedTable, SortInput },
  data() {
    return {
      loading: false,
      saving: false,
      drawerVisible: false,
      drawerMode: "create",
      rows: [],
      total: 0,
      page: 1,
      pageSize: 20,
      filters: { keyword: "", status: "" },
      form: this.emptyForm(),
      scenicOptions: [],
      rules: { scenic_id: [{ required: true, message: "请选择关联景点", trigger: "change" }], name: [{ required: true, message: "请填写点位名称", trigger: "blur" }] }
    };
  },
  mounted() {
    this.fetchList();
    this.fetchScenicOptions();
  },
  methods: {
    emptyForm() {
      return { scenic_id: null, name: "", area_label: "", point_x: 0, point_y: 0, description: "", status: "inactive" };
    },
    async fetchScenicOptions(){const res=await listResource("scenic-spots",{status:"active",page:1,pageSize:100});this.scenicOptions=res.data&&res.data.items?res.data.items:[];},
    async fetchList() {
      this.loading = true;
      try {
        const res = await listResource("scenic-map-points", { ...this.filters, page: this.page, pageSize: this.pageSize });
        this.rows = res.data && res.data.items ? res.data.items : [];
        this.total = res.data && res.data.total ? res.data.total : 0;
      } finally {
        this.loading = false;
      }
    },
    reset() {
      this.filters = { keyword: "", status: "" };
      this.page = 1;
      this.fetchList();
    },
    openCreate() {
      this.drawerMode = "create";
      this.form = this.emptyForm();
      this.drawerVisible = true;
    },
    openEdit(row) {
      this.drawerMode = "edit";
      this.form = { ...this.emptyForm(), ...row };
      this.drawerVisible = true;
    },
    save() {
      this.$refs.form.validate(async (valid) => {
        if (!valid) return;
        this.saving = true;
        try {
          if (this.drawerMode === "create") await createResource("scenic-map-points", this.form);
          else await updateResource("scenic-map-points", this.form.id, this.form);
          this.$message.success("地图点位已保存");
          this.drawerVisible = false;
          this.fetchList();
        } finally {
          this.saving = false;
        }
      });
    },
    async changeStatus(row, status) {
      await changeResourceStatus("scenic-map-points", row.id, status);
      this.$message.success(status === "active" ? "点位已显示" : "点位已隐藏");
      this.fetchList();
    },
    async changeSort(row, sortOrder) {
      await updateResource("scenic-map-points", row.id, { ...row, sort_order: sortOrder });
      this.$message.success("排序已更新");
      this.fetchList();
    },
    remove(row) {
      this.$confirm("确定删除该地图点位吗？", "删除点位", { type: "warning" })
        .then(async () => {
          await deleteResource("scenic-map-points", row.id);
          this.$message.success("点位已删除");
          this.fetchList();
        })
        .catch(() => {});
    }
  }
};
</script>
